var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Property 1=\xEC\xA0\x9C\xEB\xAA\xA9, \xEC\x83\x81\xED\x83\x9C=Default"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M10.5 16.8976H17M12.5312 5.56335L15.375 7.90837M5.21875 12.5984L13.2296 4.62236C14.0921 3.79255 15.4906 3.79255 16.3531 4.62236C17.2156 5.45217 17.2156 6.79757 16.3531 7.62738L8.0625 15.3343L4 16.5068L5.21875 12.5984Z",
    stroke: "#73757C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPencil);
export default __webpack_public_path__ + "static/media/Icon_pencil.7d2556bdbb0df80425ca4ac2e5740d38.svg";
export { ForwardRef as ReactComponent };